export const walletProductColumns = [
  {
    field: "code",
    header: "Codigo",
    align: "center",
    columnWidth: "170px"
  },
  {
    field: "name",
    header: "Producto",
    columnType: "tooltip",
    tooltipField: "name",
    truncateLength: 80,
    columnWidth: "420px",
    columnMaxWidth: "420px"
  },
  {
    field: "line_name",
    header: "Linea de negocio",
    columnType: "custom",
    align: "center",
    render: (row) => (
      <p className="table-default-column">
        {row.line_name ? row.line_name : "-"}
      </p>
    )
  },
  {
    field: "is_partial_code",
    header: "Codigo parcial",
    columnType: "custom",
    align: "center",
    columnWidth: "150px",
    render: (row) => (
      <p className="table-default-column">
        {Number(row.is_partial_code) === 1 ? "Si" : "No"}
      </p>
    )
  },
  {
    field: "actions",
    header: "Acciones",
    columnType: "actionButtons",
    columnWidth: "120px"
  }
];
